import { styled } from '@mui/material/styles';
import { Button } from 'components/buttons';
import { FormItem } from 'components/styledComponents';

export const AddButton = styled(Button)(({ theme }) => ({
  margin: `${theme.spacing(2)} 0`
}));

export const ContactSection = styled(FormItem)(() => ({
  alignContent: 'flex-start',
  '&&&': {
    marginBottom: 0,
    marginTop: 0
  }
}));

export const Subtext = styled('div')(({ theme }) => ({
  a: {
    textDecoration: 'none',
    color: theme.color.primary.main
  }
}));

export const HelpText = styled('span')(({ theme }) => ({
  color: theme.color.primary.main
}));
